// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader_g6TGHwR6hbbv8picTPgn","loading-bar-spinner":"Loader_loading-bar-spinner_D1WrVcYCJzLVW8hWKl8T"};